import { graphql } from "react-relay";

export const heatmapQuery = graphql`
  query HeatmapQuery($dateRange: DateRangeInput!, $timeZone: String!, $calendarIds: [String!]!) {
    viewer {
      user {
        orgs(first: 1000000) {
          edges {
            node {
              fetchHeatmapErrorable(
                dateRange: $dateRange
                timeZone: $timeZone
                calendarIds: $calendarIds
              ) {
                __typename
                ... on GraphEntityError {
                  message
                }
                ... on HeatmapResult {
                  crawledCalendarIds
                  uncrawledCalendarIds
                  busyHours {
                    startTime {
                      dateOrDateTime
                    }
                    endTime {
                      dateOrDateTime
                    }
                  }
                  holdHours {
                    startTime {
                      dateOrDateTime
                    }
                    endTime {
                      dateOrDateTime
                    }
                  }
                  meetingHours {
                    startTime {
                      dateOrDateTime
                    }
                    endTime {
                      dateOrDateTime
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
